import type * as React from 'react';

import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { CheckIcon, MinusIcon } from 'lucide-react';

import { cn } from '@/shadcn/lib/utils';

function Checkbox({
  className,
  indeterminate,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root> & {
  indeterminate?: boolean;
}) {
  return (
    <CheckboxPrimitive.Root
      className={cn(
        'group peer size-4.5 shrink-0 cursor-pointer rounded-[4px] border border-input shadow-xs outline-none transition-[shadow,transform] focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 active:scale-95 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 data-[state=checked]:border-primary data-[state=indeterminate]:border-input data-[state=checked]:bg-primary data-[state=indeterminate]:bg-accent data-[state=checked]:text-primary-foreground data-[state=indeterminate]:text-accent-foreground dark:aria-invalid:ring-destructive/40',
        className
      )}
      data-slot="checkbox"
      {...props}
    >
      <CheckboxPrimitive.Indicator
        className="flex items-center justify-center text-current duration-75"
        data-slot="checkbox-indicator"
      >
        <MinusIcon className="size-3.75 group-data-[state=checked]:hidden" />
        <CheckIcon className="size-3.75 group-data-[state=indeterminate]:hidden" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
